import { useAppSelector } from './useAppSelector'

export const useCurrencies = () => useAppSelector((state) => state.currencies)
